import { render, staticRenderFns } from "./allinpay_member_auth.vue?vue&type=template&id=9cab0024&scoped=true"
import script from "./allinpay_member_auth.vue?vue&type=script&lang=js"
export * from "./allinpay_member_auth.vue?vue&type=script&lang=js"
import style0 from "./allinpay_member_auth.vue?vue&type=style&index=0&id=9cab0024&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab0024",
  null
  
)

export default component.exports